// CRM-04 (revisão de 02/10, RN-02): um contato, um negócio aberto por funil. O servidor recusa com 409
// `contact_has_open_deal` o mover para uma etapa aberta quando um contato do negócio já tem outro negócio aberto no
// funil, com o contato e o id do outro negócio só para quem o vê. A tela diz o motivo e, ao administrador, oferece
// juntar os dois.

// O que a tela mostra da recusa, ou null quando o mover falhou por outro motivo.
export const recusaDeOutroAberto = error => {
  const resposta = error?.response;
  if (resposta?.status !== 409) return null;
  if (resposta.data?.error !== 'contact_has_open_deal') return null;
  return {
    otherCardId: resposta.data.card_id || null,
    contactName: resposta.data.contact?.name || '',
  };
};

export const motivoDaRecusa = (recusa, t) =>
  recusa.contactName
    ? t('KANBAN.MOVE_REFUSED.OPEN_DEAL', { name: recusa.contactName })
    : t('KANBAN.MOVE_REFUSED.OPEN_DEAL_UNNAMED');
